import { useParams } from "react-router-dom";
import { useAppSelector } from "../../stateManagement/hooks/redux";
import RoadWebCameraViewer from "../../widgets/roadWebCameraViewer/RoadWebCameraViewer";
import RoadWebCameraInfoBlock from "../../widgets/roadWebCameraViewer/RoadWebCameraInfoBlock";
import ContentHeader from "../../widgets/contentHeader/ContentHeader";

export default function RoadWebCameraPage() {

    const { roadWebCameraId }: any = useParams()
    const showCameraInfoWindow = useAppSelector(state => state.roadWebCamera.cameraInfoWindowIsShown)
    const name = `Камера ${roadWebCameraId}`

    return (
        <>
            <ContentHeader title={name} type="camera"/>
            <div className="road-web-camera-div">
                {showCameraInfoWindow && <RoadWebCameraInfoBlock />}
                <RoadWebCameraViewer />
            </div>
        </>
    )
}
